<template>
    <div>
        <!-- 内容部分的右边 -->
        <div>
            <div class="right_search flex">
                <p>{{"共上传"+productTotal+"组设计"}}</p>
                <div class="right_searchBox flex">
                    <el-input
                        placeholder="请输入关键字"
                        size="small"
                         v-model="searchResults" v-on:input="productSearch" >
                        <i slot="suffix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                   <!-- <div>
                        时间最新
                    </div>
                    <div class="selectButton">
                        <i class="el-icon-arrow-up"></i>
                        <i class="el-icon-arrow-down"></i>
                    </div>-->
                </div>
                <!-- <div class="right_times flex">
                   <p>时间最新</p>
                   <div class="right_times_icon">
                     <i class="el-icon-arrow-up"></i>
                     <i class="el-icon-arrow-down"></i>

                   </div>


                 </div>-->
            </div>
            <div v-if="productList.length==0" style="text-align:center;margin-bottom:20px" >
                    <img src="../../assets/暂无内容.jpg" alt="" style="width:200px">
                </div>
            <div class="right_list flex">
                <div
                    class="right_listbox"
                    v-for="(items, index) in productList"
                    :key="index"
                >
                    <div class="listbox_imgBoxTop" @click="toDetails(items.uuid)">
                        <div class="listbox_img">
                            <!--<el-carousel height="130px" indicator-position="none">
                                <el-carousel-item v-for="(itemImg,idnex) in items.urlList" :key="idnex">
                                    <el-image
                                        :src="itemImg.imgUrl"
                                        :preview-src-list="workdImgs"
                                    >
                                    </el-image>
                                </el-carousel-item>
                            </el-carousel>-->
                            <el-image
                                    :src="items.urlList[0].imgUrl"
                            >
                            </el-image>
                        </div>
                        <div class="listbox_center">
                            <div class="listbox_center_title flex">
                                <p>{{ items.productName }}</p>
                                <!--        <span>{{ items.time }}</span>-->
                            </div>
                            <div class="listbox_center_title flex">
                                <p class="listbox_center_des flex">{{ items.time }}</p>
                            </div>
                        </div>
                    </div>
                    <!--<div class="listbox_imgBox">-->
                        <!--<p> {{items.remark}}</p>-->
                    <!--</div>-->
                </div>
                <div class="right_listbox_o"></div>
                <div class="right_listbox_o"></div>
                <div class="right_listbox_o"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import { queryProductList} from "../../utils/interface";
    import { getHumanDate } from "../../utils/date";
    export default {
        //   平面设计
        name: "designResults",
        components: {},
        data() {
            return {
                searchResults: '',
                productList : [],
                productTotal : 0,
                productTimeOut:null,
                workdImgs: [],
                showImgs: false,
            };
        },
        created() {
            this.getProductList();
        },
        methods: {
            //跳转详情页
            toDetails(uuid){
                let routeData = this.$router.resolve({
                    name: "productWork",
                    query: { uuid: uuid, type: "DESIGN" },
                });
                window.open(routeData.href, "_blank");

            },
            productSearch(){
                if(this.productTimeOut == null){
                    this.productTimeOut = setTimeout(this.getProductList,1000);
                }else{
                    clearTimeout(this.productTimeOut);
                    this.productTimeOut = setTimeout(this.getProductList,1000);
                }
            },
            getProductList(){
                console.log(this.$parent.designer.userId)
                queryProductList({
                    userUuid : this.$parent.designer.userId,
                    productName : this.searchResults,
                    status: "RELEASED",
                    current : 1,
                    pageSize :10000,
                    productType: "DESIGN",
                }).then((res) => {
                    this.productTotal = res.total ;
                    res.list.map(item =>{
                        item.time = getHumanDate(new Date(item.createDate).getTime(),true);
                    })
                    this.productList = res.list;

                    res.list.forEach(imgs=>{
                        imgs.urlList.forEach(itemsImgs => {
                            this.workdImgs.push(itemsImgs.imgUrl)
                        })
                    })
                    // console.log('imgUrl',this.workdImgs );

                    if(this.productTimeOut!=null){
                        clearTimeout(this.productTimeOut);
                        this.productTimeOut =null;
                    }
                });
            },
        },
    };
</script>

<style scoped lang="less">
    .blue {
        color: #1181ff;
    }

    /* 内容部分的右边 */

    .right_search {
        justify-content: space-between;
        align-items: center;
        margin: 13px 0 20px;
        .right_searchBox{
            font-size: 14px;
            color: #262626;
            /deep/.el-input__inner{
                border-radius: 30px;
            }
            .selectButton{
                padding-left: 18px;
                position: relative;
                i{
                    display: block;
                    font-size: 12px;
                    color: #262626;
                    cursor: pointer;
                    position: absolute;
                }
                .el-icon-arrow-up{
                    right: 0;
                    top: 0;
                }
                .el-icon-arrow-down{
                    right: 0;
                    bottom: 0;
                }
            }
        }
        p {
            font-size: 14px;
        }

        .right_times {
            font-size: 14px;
            align-items: center;

            .right_times_icon {
                margin-left: 5px;

                i {
                    display: block;
                    height: 10px;
                    font-size: 10px;
                }
            }
        }
    }

    .right_list {
        justify-content: space-between;
        flex-wrap: wrap;

        .right_listbox_o {
            width: 208px;
            height: 0;
        }
        .right_listbox:nth-of-type(4n+4):hover .listbox_imgBox{
            right: -6px !important;
            p {
                left: 0;
            }
        }
        .right_listbox {
            cursor: pointer;
            width: 208px;
            border: 1px solid #efefef;
            border-radius: 8px;
            margin-bottom: 26px;
            background: #fff;
            position: relative;
            display: flex;
            &:hover .listbox_imgBox{
                display: block;
                p {
                    right: 0;

                }
            }
            &:hover .listbox_img{
                display: block;
                z-index: 4;
            }
            &:hover .listbox_center .listbox_center_title p {
                z-index: 11;
            }
            &:hover .listbox_center_des {
                z-index: 13;
            }
            .listbox_img {
                width:  208px;
                height: 130px;
                background: #efefef;
                border-radius: 8px;
                position: relative;
                /deep/.el-image {
                    width: 208px;
                    height: 100%;
                    border-radius: 8px 8px 0 0;
                }
                img {
                    width: 208px;
                    height: 100%;
                    border-radius: 8px 8px 0 0;
                }
            }
            .listbox_imgBox {
                display: none;
                width: 410px;
                // height: 130px;
                height: 210px;
                position: absolute;
                top: -6px;
                font-size: 14px;
                background: #fff;
                box-shadow: 0px 0px 16px 0px #dfdfdf;
                z-index: 3;
                p {
                    margin: 10px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 8;
                    overflow: hidden;
                    width: 180px;
                    position: absolute;
                    line-height: 24px;
                }
            }

            .listbox_center {
                padding: 18px 8px 13px;
                border-bottom: 1px solid #efefef;

                .listbox_center_title {
                    justify-content: space-between;
                    align-items: center;
                    span {
                        font-size: 12px;
                        color: rgb(184, 184, 184);
                    }
                    // p {
                    //     z-index: 11;
                    // }
                }

                .listbox_center_des {
                    font-size: 10px;
                    color: #ababab;
                    margin-top: 5px;
                }
            }

            .listbox_bottom {
                padding: 10px 10px 15px;
                font-size: 13px;
                color: #ababab;
                justify-content: space-between;
                align-items: center;

                i {
                    margin-right: 2px;
                }

                p {
                    align-items: center;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/design/designs.vue